import { create } from 'zustand'
import isScreenSmall from '../isScreenSmall';

const useStore = create((set) => ({

    nav: null,

    setNav: (show) => set(state => {

        return {...state, nav: show}
    }),

    toggleNav: () => set(state => {

        return {...state, nav: !state.nav}
    }),

    setupNav: () => set(state => {

        return {...state, 
            nav: state.nav === null ? !isScreenSmall() : state.nav
        }
    }),

    resetNav: () => set(state => {

        return {...state, nav: null}
    }),

}))


export default useStore;